import * as yup from 'yup';
import emailValidator from '@hero/validators/email';
const changeEmailSchema = yup
    .object()
    .shape({
    email: yup.lazy((val) => !val ? yup.string().trim().required('Email address is required') : emailValidator),
    revoke_tokens: yup.boolean().default(false)
})
    .defined();
export default changeEmailSchema;
